/* eslint-disable array-callback-return */
import { dashboardOrderList } from "./APIResources";
import { getCurrentUser } from "aws-amplify/auth";
import { DashboardListItems } from "./types";
import { axiosWithAPIKey } from "../../Services/Axios";

export type FetchDashboardProps = {
    page_number?: number | undefined;
    page_size?: number | undefined;
}

export async function fetchDashboardList({ page_number= 1, page_size = 10}: FetchDashboardProps) {
    let provider = await getCurrentUser();
    try {
        // let response: APIResponseType<any>;
        return await axiosWithAPIKey.get(dashboardOrderList +"/?provider_id="+provider.username+`${page_number && page_size ? `&page_number=${page_number}&page_size=${page_size}` : ''}`).then((res: any) => {
            if (res.data.status && res.data.code === 200) {
                let dashboardPatientList: any = [];
                 res.data.data.map((patient: any) => {
                    let tempPatients: DashboardListItems = {
                        firstname: patient.patient_data.firstname,
                        lastname: patient.patient_data.lastname,
                        kiddoBandID: patient?.order_mongo_data?.serial_number ?? "",
                        medicalCondition: patient.patient_data.medicalCondition,
                        kiddoBandStatus: patient.lead_data.current_status,
                        orderDate: patient.lead_data.lead_gen_time
                    }
                    dashboardPatientList.push(tempPatients);
                });
                return  { success: true, data: dashboardPatientList, message: "Patients found", code: "200", pagination: {
                    page_number: page_number,
                    page_size: page_size,
                    total_records: res.data.pagination.total_records
                }};
            } else {
                return { success: false, code: res.data.code, message: res.data.message };
            }
        }).catch((error: any) => {
            return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
        });
    } catch (error: any) {
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}